import { getAuth } from '../../util';

const AGENT_URL = 'https://estimator.spinnax.com/api/generate';

export async function askAgent(prompt: string): Promise<string> {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) throw new Error('User not authenticated');
    const token = await user.getIdToken();

    const response = await fetch(AGENT_URL, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model: 'gemma:2b',
        prompt,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Agent API error: ${errorText}`);
    }

    // Streaming-Response verarbeiten:
    const reader = response.body?.getReader();
    let resultText = '';
    if (reader) {
      const decoder = new TextDecoder();
      let done = false;
      let buffer = '';
      while (!done) {
        const { value, done: doneReading } = await reader.read();
        done = doneReading;
        if (value) {
          buffer += decoder.decode(value, { stream: true });
          let lines = buffer.split('\n');
          buffer = lines.pop() || '';
          for (const line of lines) {
            if (line.trim()) {
              try {
                const obj = JSON.parse(line);
                if (obj.response) resultText += obj.response;
              } catch (e) {
                // ignore parse errors for incomplete lines
              }
            }
          }
        }
      }
      // Letzten Rest verarbeiten
      if (buffer.trim()) {
        try {
          const obj = JSON.parse(buffer);
          if (obj.response) resultText += obj.response;
        } catch (e) {}
      }
      return resultText.trim();
    } else {
      // Fallback für nicht-streaming
      const result = await response.json();
      return result.response || result.answer || JSON.stringify(result);
    }
  } catch (error: any) {
    return `Fehler: ${error.message}`;
  }
}
